import { Injectable, Injector } from '@angular/core';
import { PaginatedResponse } from '../../core/declarations/paginated.interface';
import {
  Group,
  GroupDetail,
  GroupFilterParams,
  GroupParams
} from '@bling-fe/shared/declarations';
import {
  DefineRepositoryParams,
  RepositoryAbstract
} from './repository.abstract';
import { Observable } from 'rxjs';

export type GroupRepositoryParams = DefineRepositoryParams<
  GroupDetail,
  {
    all: PaginatedResponse<Group>;
    queryParams: GroupFilterParams;
    createParams: GroupParams;
  }
>;

@Injectable({
  providedIn: 'root'
})
export class GroupRepository extends RepositoryAbstract<GroupRepositoryParams> {
  constructor(injector: Injector) {
    super(`/groups`, injector);
  }

  getMyGroups(): Observable<Group[]> {
    return this.http.get<Group[]>(`${this.RESOURCE_URL}/my_groups`);
  }

  getRecommendedGroups(): Observable<Group[]> {
    return this.http.get<Group[]>(`${this.RESOURCE_URL}/recommended`);
  }

  activate(id: number): Observable<GroupDetail> {
    return this.http.post<GroupDetail>(
      `${this.RESOURCE_URL}/${id}/activate`,
      {}
    );
  }
}
